import * as React from 'react';
import { Box, Card, CardActions, Button, Typography, Divider } from '@mui/material';
import { Link } from 'react-router-dom';

export default function CustomCard(props) {
  return (
    <Box sx={{ minWidth: 240, display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100%' }}>
      <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px', width: '100%', justifyContent: 'end' }} elevation={3}>
        <div>
          <Box className='mb-2' sx={{ color: `${props.color ? props.color : 'secondary.main'}` }}>
            <i className={props.cardIco}></i>
          </Box>
        </div>
        <div>
          <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
            {props.title}
          </Typography>
          <Typography variant="body1" className='p-1'>
            {props.text}
          </Typography>
        </div>
        <Divider variant="middle" className='my-1' sx={{ width: '100%' }} />
        <div>
          <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
            <Link to={props.to} style={{ textDecoration: 'none' }}>
              <Button color={props.btnColor ? props.btnColor : 'secondary'} variant='outlined'>{props.button} &nbsp; {props.buttonIco ? <i className={props.buttonIco}></i> : <i className="fad fa-arrow-circle-right"></i>}</Button>
            </Link>
          </CardActions>
        </div>
      </Card>
    </Box>
  );
}